<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                <pageaddheader :title="title" :title1="title1" :items="items" />
                <div class="card">
                    <div class="card-body">
                        <!-- table-top -->
                        <div class="d-flex align-items-center mb-3">
                            <div class="d-flex justify-content-start gap-2 w-100 ">
                                <div class="">
                                    <div class="form-group">
                                        <label>Date </label>
                                        <div class="input-groupicon" style="z-index: 100;">
                                            <datepicker v-model="currentDate" class="picker" :editable="true"
                                                :clearable="false" required @update:modelValue="index" />
                                            <a class="addonset">
                                                <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-25">
                                    <div class="form-group">
                                        <label>Filter<span class="text-danger">*</span></label>
                                        <vue-select :options="Jeniskehadiranlist"
                                            :settings="{ settingOption: value, settingOption: value }"
                                            v-model="jenis_kehadiran" placeholder="None">
                                        </vue-select>
                                    </div>
                                </div>
                                <div class="search-set">
                                   

                                    <div class="search-input">
                                        <a class="btn btn-searchset"><img
                                                src="../../../assets/img/icons/search-white.svg" alt="img" /></a>
                                        <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                            <label>
                                                <input type="search" class="form-control form-control-sm"
                                                    placeholder="Search..." aria-controls="DataTables_Table_0"
                                                    v-model="query" />
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="wordset " style="margin-top: 28px;">
                                    <ul>
                                        <!-- import from excel -->
                                        <li class="" >
                                            <router-link data-bs-toggle="tooltip" data-bs-placement="top" title="Import From Excel" class=" d-flex flex-column justify-content-center  align-items-center btn btn-primary p-0" style="width: 34px; height: 34px;" to="importattendancexls" >
                                                <img src="../../../assets/img/import-from-excel.png" alt="img" width="25" />
                                            </router-link>
                                        </li>
                                        <!-- export from excel -->
                                        <li class="">
                                            
                                            <a @click="export_xls" title="Export to Excel" class="d-flex flex-column justify-content-center  align-items-center btn btn-primary p-0" style="width: 34px; height: 34px;">
                                                <img src="../../../assets/img/Import_fill.png" alt="img" width="25" />
                                            </a>
                                        </li>

                                        <!-- import from SQLite -->
                                        <!-- <li class="" v-if="showSyncHistoryButton != ''">
                                            <router-link data-bs-toggle="tooltip" data-bs-placement="top" title="Import From SQLite" class=" d-flex flex-column justify-content-center  align-items-center btn btn-primary p-1" to="importattendance">
                                                <img src="../../../assets/img/import-from-excel.png" alt="img" width="40" />
                                            </router-link>
                                        </li> -->

                                        <!-- Sync with anviz machine -->
                                        <li v-if="showSyncHistoryButton != ''">
                                            

                                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="sync Machine"
                                                @click="syncHistory"
                                                v-if="isanviz != ''"
                                                class="d-flex flex-column justify-content-center align-items-center btn btn-primary p-1"
                                                :disabled="isSyncing" :style="isSyncing ? 'pointer-events: none; cursor: default;' : 'pointer-events: auto; cursor: pointer;'"> <!-- Make sure clickable is off when disabled -->
                                                
                                                <template v-if="isSyncing">
                                                    <div class="spinner-border spinner-border-sm text-light" style="padding: 10px" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                </template>
                                                
                                                <template v-else >
                                                    <vue-feather type="repeat" style="color: white; font-size: 25px"></vue-feather>
                                                </template>
                                            </a>
                                        </li>

                                    </ul>
                                </div>
                            </div>

                            
                        </div>
                        <!-- /Filter -->


                        <div class="table-responsive" v-if="setting_break_button == '0'">
                            <a-table :columns="columnsA" :data-source="filteredData" @change="handleTableChange" :pagination="pagination" :loading="loading">
                                <template #bodyCell="{ column, record }">
                                    <template v-if="column.key === 'no'">
                                        {{ record.no }}
                                    </template>
                                    <template v-if="column.key === 'nama'">
                                        <a href="javascript:void(0);" @click.prevent="openNewTab(record)" style="cursor:pointer; color:#637381">
                                            {{ record.nama }}
                                        </a>
                                    </template>
                                    <template v-if="column.key === 'tanggal'">
                                        {{ record.tanggal }}
                                    </template>
                                    <template v-if="column.key === 'jenis_kehadiran'">
                                        <span :class="record.jenis_kehadiran === 'TERLAMBAT' ? 'text-danger' : ''">
                                            {{ record.jenis_kehadiran }}
                                        </span>
                                    </template>
                                    <template v-if="column.key === 'nama_shift'">
                                        {{ record.nama_shift }}
                                    </template>
                                    <template v-if="column.key === 'jam_masuk'">
                                        <div class="productimgname d-flex flex-column">
                                            <div :class="record.jenis_kehadiran === 'TERLAMBAT' ? 'text-danger' : ''">{{ record.jam_masuk }}</div>
                                            <div href="javascript:void(0);" class="product-img"
                                                v-if="record.gambar_masuk != ''">
                                                <img :src="record.gambar_masuk"
                                                    @click="previewImage(record.gambar_masuk)" alt="clockin"
                                                    style="cursor: pointer;" />
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'jam_pulang'">
                                        <div class="productimgname d-flex flex-column">
                                            <div>{{ record.jam_pulang }}</div>
                                            <div href="javascript:void(0);" class="product-img"
                                                v-if="record.gambar_pulang != ''">
                                                <img :src="record.gambar_pulang"
                                                    @click="previewImage(record.gambar_pulang)" alt="clockin"
                                                    style="cursor: pointer;" />
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else-if="column.key === 'action'">
                                        <a href="javascript:void(0);" class="me-3" v-if="isanviz != ''" @click.prevent="openHistoryLog(record)" style="cursor:pointer; color:#637381; font-size: 20px;">
                                            <i class='bx bx-history'></i>
                                        </a>

                                        <a href="javascript:void(0);" class="me-3" :class="{ 'd-none': record.jenis_kehadiran == 'ABSENT' }" @click.prevent="openNewTab(record)" style="cursor:pointer; color:#637381">
                                            <img src="../../../assets/img/icons/edit.svg" alt="img" />
                                        </a>
                                        
                                        <a class="confirm-text" :class="{ 'd-none': record.jenis_kehadiran == 'ABSENT' }" href="javascript:void(0);"
                                            @click="terminate(record.last_id, record.tanggal_asli, record.employee_id); showModal('terminate');">
                                            <img src="@/assets/img/icons/delete.svg" alt="img" />
                                        </a>
                                    </template>
                                </template>
                            </a-table>
                        </div>
                        <div class="table-responsive" v-if="setting_break_button == '1'">
                            <a-table :columns="columnsB" :data-source="filteredData">
                                <template #bodyCell="{ column, record }">
                                    <template v-if="column.key === 'no'">
                                        {{ record.no }}
                                    </template>
                                    <template v-if="column.key === 'nama'">
                                        <a href="javascript:void(0);" @click.prevent="openNewTab(record)" style="cursor:pointer; color:#637381">
                                            {{ record.nama }}
                                        </a>
                                    </template>
                                    <template v-if="column.key === 'tanggal'">
                                        {{ record.tanggal }}
                                    </template>
                                    <template v-if="column.key === 'jenis_kehadiran'">
                                        <span :class="record.jenis_kehadiran === 'TERLAMBAT' ? 'text-danger' : ''">
                                            {{ record.jenis_kehadiran }}
                                        </span>
                                    </template>
                                    <template v-if="column.key === 'nama_shift'">
                                        {{ record.nama_shift }}
                                    </template>
                                    <template v-if="column.key === 'jam_masuk'">
                                        <div class="productimgname d-flex flex-column">
                                            <div :class="record.jenis_kehadiran === 'TERLAMBAT' ? 'text-danger' : ''">{{ record.jam_masuk }}</div>
                                            <div href="javascript:void(0);" class="product-img"
                                                v-if="record.gambar_masuk != ''">
                                                <img :src="record.gambar_masuk"
                                                    @click="previewImage(record.gambar_masuk)" alt="clockin"
                                                    style="cursor: pointer;" />
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="column.key == 'jam_istirahat_keluar'">
                                        <div class="productimgname d-flex flex-column ">
                                            <div>{{ record.jam_istirahat_keluar }} </div>
                                            <div href="javascript:void(0);" class="product-img"
                                                v-if="record.gambar_istirahat_keluar != ''">
                                                <img :src="record.gambar_istirahat_keluar"
                                                    @click="previewImage(record.gambar_istirahat_keluar)" alt="clockin"
                                                    style="cursor: pointer;" />
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'jam_istirahat_masuk'">
                                        <div class=" productimgname d-flex flex-column ">
                                            <div>{{ record.jam_istirahat_masuk }}</div>
                                            <div href="javascript:void(0);" class="product-img"
                                                v-if="record.gambar_istirahat_masuk != ''">
                                                <img :src="record.gambar_istirahat_masuk"
                                                    @click="previewImage(record.gambar_istirahat_masuk)" alt="clockin"
                                                    style="cursor: pointer;" />
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'jam_pulang'">
                                        <div class="productimgname d-flex flex-column">
                                            <div>{{ record.jam_pulang }}</div>
                                            <div href="javascript:void(0);" class="product-img"
                                                v-if="record.gambar_pulang != ''">
                                                <img :src="record.gambar_pulang"
                                                    @click="previewImage(record.gambar_pulang)" alt="clockin"
                                                    style="cursor: pointer;" />
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else-if="column.key === 'action'">
                                        <a href="javascript:void(0);" class="me-3" v-if="isanviz != ''" @click.prevent="openHistoryLog(record)" style="cursor:pointer; color:#637381; font-size: 20px;">
                                            <i class='bx bx-history'></i>
                                        </a>
                                        
                                        <a href="javascript:void(0);" @click.prevent="openNewTab(record)" style="cursor:pointer; color:#637381">
                                            <img src="../../../assets/img/icons/edit.svg" alt="img" />
                                        </a>
                                        
                                        <a class="confirm-text" href="javascript:void(0);"
                                            @click="terminate(record.last_id, record.tanggal_asli, record.employee_id); showModal('terminate');">
                                            <img src="@/assets/img/icons/delete.svg" alt="img" />
                                        </a>
                                    </template>
                                </template>
                            </a-table>
                        </div>
                    </div>
                </div>
               
              

            </div>
        </div>

        <!-- preview Image clock in & out modal -->
        <div class="modal fade" id="previewImage" ref="previewImage" tabindex="-1" role="dialog"
            aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Preview Image</h5>
                        <button type="button" class="close" @click="hideModal2('previewImage')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    
                    <div class="modal-body d-flex justify-content-center">
                        <img :src="selectedImage" class="img-fluid" alt="clock-in"  style="max-height: 380px; object-fit: contain;" />
                    </div>
                    <div class="modal-footer d-flex justify-content-end">
                        <button type="button" class="btn  btn-primary"
                            @click="hideModal2('previewImage')">Close</button>
                    </div>
                    
                </div>
            </div>
        </div>

        <!-- delete modal -->
        <div class="modal fade" id="terminate" ref="terminate" tabindex="-1" role="dialog"
            aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Delete Data</h5>
                        <button type="button" class="close" @click="hideModal2('terminate')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form @submit.prevent="delete2">
                        <div class="modal-body">
                            Are u sure want to delete this data?
                        </div>
                        <div class="modal-footer d-flex justify-content-end">
                            <button type="button" class="btn  btn-secondary"
                                @click="hideModal2('terminate')">cancel</button>
                            <button type="submit" class="btn  btn-danger">Delete</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>


        <!-- history modal -->
        <div class="modal fade" id="historyModal" ref="historyModal" tabindex="-1" role="dialog"
            aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">History Log</h5>
                        <button type="button" class="close" @click="hideModal2('historyModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table table-responsive">
                            <thead>
                                <tr>
                                    <td>Name</td>
                                    <td>Employee ID</td>
                                    <td>Check Date</td>
                                    <td>Check Time</td>
                                    <td>Check Type</td>
                                    <td>Device Name</td>
                                    <td>Device SN</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in logData" :key="index">
                                    <td>{{ item.employee_name }}</td>
                                    <td>{{ item.employee_workno }}</td>
                                    <td>{{ item.check_date }}</td>
                                    <td>{{ item.check_time }}</td>
                                    <td>{{ item.check_type }}</td>
                                    <td>{{ item.device_name }}</td>
                                    <td>{{ item.device_serial_number }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer d-flex justify-content-end">
                        
                        <!-- <button type="submit" class="btn  btn-danger">Delete</button> -->
                    </div>
                    <!-- <form @submit.prevent="delete2">
                    </form> -->
                </div>
            </div>
        </div>

    </div>
</template>


<script>

import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, openInNewTab, AlertBottom, selectedBranch, appendForm, timeout, } from "@/assets/js/function";
import { watch } from "vue";

export default {
    data() {
        return {

            title: "History Attendance",
            title1: "View all history attendance",
            items: [
                {
                    text: "Add New Attendance",
                    addname: "/addattendance",
                },
            ],

            //data
            data: [],
            logData: [],
            columnsA: [
                {
                    title: "No",
                    dataIndex: "no",
                    key: "no",
                    fixed: 'left',
                    sorter: {
                        compare: (a, b) => {
                            a = a.no.toLowerCase();
                            b = b.no.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Name",
                    dataIndex: "nama",
                    key: "nama",
                    fixed: 'left',
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama.toLowerCase();
                            b = b.nama.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Date",
                    dataIndex: "tanggal",
                    key: "tanggal",
                    fixed: 'left',
                    sorter: {
                        compare: (a, b) => {
                            a = a.tanggal.toLowerCase();
                            b = b.tanggal.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Type of Attendance",
                    dataIndex: "jenis_kehadiran",
                    key: "jenis_kehadiran",
                    sorter: {
                        compare: (a, b) => {
                            a = a.jenis_kehadiran.toLowerCase();
                            b = b.jenis_kehadiran.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Shift",
                    dataIndex: "nama_shift",
                    key: "nama_shift",
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama_shift.toLowerCase();
                            b = b.nama_shift.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Clock in",
                    dataIndex: "jam_masuk",
                    key: "jam_masuk",
                    sorter: {
                        compare: (a, b) => {
                            a = a.jam_masuk.toLowerCase();
                            b = b.jam_masuk.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Clock Out",
                    dataIndex: "jam_pulang",
                    key: "jam_pulang",
                    sorter: {
                        compare: (a, b) => {
                            a = a.jam_pulang.toLowerCase();
                            b = b.jam_pulang.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },


                {
                    title: "Actions",
                    key: "action",
                    sorter: false,
                    fixed: 'right'
                },
            ],
            columnsB: [
                {
                    title: "No",
                    dataIndex: "no",
                    key: "no",
                    fixed: 'left',
                    sorter: {
                        compare: (a, b) => {
                            a = a.no.toLowerCase();
                            b = b.no.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Name",
                    dataIndex: "nama",
                    key: "nama",
                    fixed: 'left',
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama.toLowerCase();
                            b = b.nama.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Date",
                    dataIndex: "tanggal",
                    key: "tanggal",
                    fixed: 'left',
                    sorter: {
                        compare: (a, b) => {
                            a = a.tanggal.toLowerCase();
                            b = b.tanggal.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Type of Attendance",
                    dataIndex: "jenis_kehadiran",
                    key: "jenis_kehadiran",
                    sorter: {
                        compare: (a, b) => {
                            a = a.jenis_kehadiran.toLowerCase();
                            b = b.jenis_kehadiran.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Shift",
                    dataIndex: "nama_shift",
                    key: "nama_shift",
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama_shift.toLowerCase();
                            b = b.nama_shift.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Clock in",
                    dataIndex: "jam_masuk",
                    key: "jam_masuk",
                    sorter: {
                        compare: (a, b) => {
                            a = a.jam_masuk.toLowerCase();
                            b = b.jam_masuk.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Break out",
                    dataIndex: "jam_istirahat_keluar",
                    key: "jam_istirahat_keluar",
                    sorter: {
                        compare: (a, b) => {
                            a = a.jam_istirahat_keluar.toLowerCase();
                            b = b.jam_istirahat_keluar.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Break in",
                    dataIndex: "jam_istirahat_masuk",
                    key: "jam_istirahat_masuk",
                    sorter: {
                        compare: (a, b) => {
                            a = a.jam_istirahat_masuk.toLowerCase();
                            b = b.jam_istirahat_masuk.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Clock Out",
                    dataIndex: "jam_pulang",
                    key: "jam_pulang",
                    sorter: {
                        compare: (a, b) => {
                            a = a.jam_pulang.toLowerCase();
                            b = b.jam_pulang.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Actions",
                    key: "action",
                    sorter: false,
                    fixed: 'right',
                },
            ],

            api: "",
            config: "",
            currentDate: new Date(),
            jenis_kehadiran: "SEMUA",
            Jeniskehadiranlist: [
                {
                    id: 'SEMUA',
                    text: "ALL",
                },
                {
                    id: "HADIR",
                    text: "HADIR",
                },
                {
                    id: "IZIN",
                    text: "IZIN",
                },
                {
                    id: "TERLAMBAT",
                    text: "TERLAMBAT",
                },
                {
                    id: "CUTI",
                    text: "CUTI",
                },
                {
                    id: "ABSENT",
                    text: "ABSENT",
                },
                
                
            ],

            //filter
            value: "",
            query: "",
            showSyncHistoryButton: "",
            isSyncing: false,   // To show spinner and disable button
            pagination: {
                current: 1,
                pageSize: 10,
                showSizeChanger: false
            },
            loading: false,

            
            id_terminate: "",
            tanggal_terminate: "",
            employee_id_terminate: "",
            setting_break_button: "0",

            selectedImage: '',
        };

    },
    name: "activities",

    async created() {
        const token = Cookies.get("token_refresh");
        this.config = {
            headers: { Authorization: `Bearer ` + token },
            timeout: 30000,
        }
        
        const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

        //Update local and shared state
        this.filter = branch;
        selectedBranch.value = branch;

        // await fetchMasterData();
        localStorage.setItem('actionState', 'view')

        await this.index();

    },

    mounted() {

        watch(selectedBranch, () => {
            this.index()
        }, { immediate: true })

        const savedPage = localStorage.getItem("lastPage");
        if (savedPage) {
            this.pagination.current = parseInt(savedPage);
        }
    },
    

    computed: {
        filteredData() {
            // Filter data based on selected jenis_kehadiran
            if (!this.jenis_kehadiran || (this.jenis_kehadiran == 'SEMUA' && this.query == '')) {
                return this.data;
            } else if (this.jenis_kehadiran != 'SEMUA' && this.query == '') {
                return this.data.filter(item => item.jenis_kehadiran === this.jenis_kehadiran);
            } else if (this.jenis_kehadiran == 'SEMUA' && this.query != '') {
                const lowerCaseQuery = this.query.toLowerCase(); // Optional: Convert to lowercase for case-insensitive comparison
                return this.data.filter(
                    (item => item.nama.toLowerCase().includes(lowerCaseQuery) ||
                        item.jam_masuk.toLowerCase().includes(lowerCaseQuery) ||
                        item.jam_pulang.toLowerCase().includes(lowerCaseQuery)
                    )
                );

            } else if (this.jenis_kehadiran != 'SEMUA' && this.query != '') {
                const lowerCaseQuery = this.query.toLowerCase(); // Optional: Convert to lowercase for case-insensitive comparison
                return this.data.filter(
                    (item => item.nama.toLowerCase().includes(lowerCaseQuery) && item.jenis_kehadiran === this.jenis_kehadiran ||
                        item.jam_masuk.toLowerCase().includes(lowerCaseQuery) && item.jenis_kehadiran === this.jenis_kehadiran) ||
                    item.jam_pulang.toLowerCase().includes(lowerCaseQuery) && item.jenis_kehadiran === this.jenis_kehadiran
                );
            }

        }
    },

    methods: {
        openInNewTab,
        hideColumn() {
            let breakOutIndex = -1;
            document.querySelectorAll('thead th').forEach((th, index) => {
                if (th.innerText.includes('Break out')) {
                    th.classList.add('d-none'); // hide the header
                    breakOutIndex = index;
                }
            });

            // Now hide each <td> at that column index
            if (breakOutIndex != -1) {
                document.querySelectorAll('tbody tr').forEach(tr => {
                    const tds = tr.querySelectorAll('td');

                    if (tds[breakOutIndex]) {
                        console.log('test');
                        tds[breakOutIndex].classList.add('d-none');
                    }
                });
            }
        },

        previewImage(src) {
            this.selectedImage = src;
            this.showModal('previewImage');
        },

        handleTableChange(pagination) {
            this.pagination = pagination; // keep pagination reactive
            localStorage.setItem("lastPage", pagination.current);
        },

        showModal(modal_name) {
        
            const modal = this.$refs[modal_name];
            
            // Show modal
            modal.classList.add('show');
            modal.style.display = 'block';

            // Add backdrop manually
            const backdrop = document.createElement('div');
            backdrop.className = 'modal-backdrop fade show';
            backdrop.setAttribute('data-modal-backdrop', modal_name); // optional attribute to identify
            document.body.appendChild(backdrop);

            // Prevent body scroll
            document.body.classList.add('modal-open');
        },

        hideModal2(modal_name) {
            const modal = this.$refs[modal_name];
            
            // Hide modal
            modal.classList.remove('show');
            modal.style.display = 'none';
    
            // Remove backdrop
            const backdrop = document.querySelector(`.modal-backdrop[data-modal-backdrop="${modal_name}"]`);
            if (backdrop) backdrop.remove();
    
            // Remove scroll lock
            document.body.classList.remove('modal-open');
        },

        formatDateLocal(date) {
            console.log('ini tanggal', date)
            if (!date) return "";

            const parsedDate = date instanceof Date ? date : new Date(date);

            if (isNaN(parsedDate.getTime())) return ""; // invalid date

            const year = parsedDate.getFullYear();
            const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Month is 0-based
            const day = String(parsedDate.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },

        async openHistoryLog(record) {
            this.loading = true;

            const formData = new FormData();
            appendForm(formData);

            formData.append("tanggal", this.formatDateLocal(this.currentDate));
            formData.append("employee_id", record.employee_id);

            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            // return

            const api = base_url + '/v3/attendances/anviz_index';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            
            console.log(" History", data);
            
            if(data.status){
                const history = data.data.data_history

                this.logData = [];
                history.forEach((item, index) => {
                    const item_prepare = {
                        ...item,
                        no: index + 1,
                        
                        };
                    this.logData.push(item_prepare);
                });
   
                this.showModal('historyModal')

                this.loading = false;
                // console.log('tes seting break button', this.setting_break_button)
                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }
            
            
        },

        async index() {
            this.loading = true;

            const formData = new FormData();
            appendForm(formData);

            formData.append("tanggal", this.formatDateLocal(this.currentDate));

            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            // return

            const api = base_url + '/v3/attendances/index';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            const history = data.data.data_history
           
            console.log(" History", data);

            if(data.status){

                this.data = [];
                history.forEach((item, index) => {
                    const item_prepare = {
                        ...item,
                        no: index + 1,
                        
                        };
                    this.data.push(item_prepare);
                });
   
                this.setting_break_button = data.data.setting_break_button;
                localStorage.setItem('employeeList', JSON.stringify(data.data.data_employee))
                localStorage.setItem('setting_break_button', this.setting_break_button);
                localStorage.setItem('shiftList', JSON.stringify(data.data.data_shift));
                this.showSyncHistoryButton = data.data.is_anviz;

                this.loading = false;
                // console.log('tes seting break button', this.setting_break_button)
                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }
            
            
        },

       
        
        async syncHistory() {
            this.isSyncing = true;

            try {

                

                // const config = {
                //     headers: { Authorization: `Bearer ` + Cookies.get("token_refresh") },
                //     timeout: 0,
                // }

                const api = this.showSyncHistoryButton;
                const res = await axios.get(api);
                const data = res.data;
                // console.log("INI DATA delete", data);

                if(data.status){
                    AlertBottom(data.data.message);

                    this.data = [];
                    this.index();
                }else {
                    AlertPopup2("error", "", data.data.message, true, 1500);

                }

            } catch (error) {
                console.error('Sync failed', error);
            } finally {
                this.isSyncing = false;
            }

        },
        
        terminate(id, tanggal_terminate, employee_id) {
            this.id_terminate = id;
            this.tanggal_terminate = tanggal_terminate;
            this.employee_id_terminate = employee_id

        },
        async delete2() {
          
            const formData = new FormData();
            appendForm(formData)

            formData.append("last_id", this.id_terminate);
            formData.append("employee_id", this.employee_id_terminate);
            formData.append("tanggal", this.formatDateLocal(this.tanggal_terminate));


            for (let [key, value] of formData.entries()) {
                console.log(`${key}: ${value}`);
            }

           

            const api = base_url + '/v3/attendances/delete';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;

            if (data.status) {
               

                const index = this.data.findIndex((record) => record.id === this.id_terminate);
                this.data.splice(index, 1);
                AlertBottom(data.message);
                this.hideModal2('terminate');
                
            } else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

            

        },

        openNewTab(record) {
            localStorage.setItem("currentData", JSON.stringify(record));
            window.open("/editattendance", "_blank");
        },

        async export_xls() {
            let formData = new FormData();
            appendForm(formData)
            
           

            

            formData.append("tanggal", this.formatDateLocal(this.currentDate));

            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            // CloseLoading()
            // return true

            const api = base_url + '/v3/attendances/export';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;

            if(data.status){
                 const fileUrl = data.data?.file_report;

               

                if (!fileUrl) {
                    AlertPopup2("error", "", "Download link not found", true, 1500);
                   
                    return;
                }

                const link = document.createElement("a");
                link.href = fileUrl;
                link.download = "kehadiran.xlsx";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            }else {
                AlertPopup2("error", "", data.message || "Unknown error", true, 1500);
            }

            
        },
    }
};
</script>